import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import Banner from "./Banner.js"; // Add .js extension
import IMAGES from "../assets/index.js"; // Add .js extension

function Header() {
  const [expanded, setExpanded] = useState(false);
  const [activeLink, setActiveLink] = useState("home");
  const isScrolling = useRef(false);

  // Toggle mobile menu
  const toggleMenu = () => {
    setTimeout(() => {
      setExpanded(!expanded);
    }, 10);
  };

  // Scroll to Top and Set Home as Active
  const scrollToTop = () => {
    isScrolling.current = true;

    document.querySelectorAll(".navbar-nav .nav-link").forEach((link) => {
      link.classList.remove("active");
    });

    setActiveLink("home");
    const homeLink = document.querySelector(".nav-link-home");
    if (homeLink) {
      homeLink.classList.add("active");
    }

    window.scrollTo({ top: 0, behavior: "smooth" });

    setTimeout(() => {
      isScrolling.current = false;
    }, 1000);

    setExpanded(false);
  };

  // Handle Navigation Clicks
  const handleNavClick = (section) => {
    setActiveLink(section);
    setExpanded(false);
  };

  // Scroll Event Listener
  useEffect(() => {
    const handleScroll = () => {
      if (isScrolling.current) return;

      const scrollPosition = window.scrollY;
      let activeSection = "home";

      if (scrollPosition < 100) {
        // If near the top, ensure Home is active
        setActiveLink("home");
        document.querySelectorAll(".navbar-nav .nav-link").forEach((link) => {
          link.classList.remove("active");
        });

        const homeLink = document.querySelector(".nav-link-home");
        if (homeLink) {
          homeLink.classList.add("active");
        }
        return;
      }

      // Other sections detection
      const sections = [
        { id: "classes", element: document.getElementById("classes") },
        { id: "pricing", element: document.getElementById("pricing") },
        { id: "pictures", element: document.getElementById("pictures") },
        { id: "about", element: document.getElementById("about") },
        { id: "contact", element: document.getElementById("contact") },
      ].filter((section) => section.element);

      for (const section of sections) {
        const rect = section.element.getBoundingClientRect();
        if (rect.top <= 300 && rect.bottom >= 300) {
          activeSection = section.id;
          break;
        }
      }

      // Update active section only if it has changed
      if (activeSection !== activeLink) {
        setActiveLink(activeSection);
        document.querySelectorAll(".navbar-nav .nav-link").forEach((link) => {
          link.classList.remove("active");
        });

        const targetLink = document.querySelector(
          `.navbar-nav .nav-link[href="#${activeSection}"]`
        );
        if (targetLink) {
          targetLink.classList.add("active");
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeLink]);

  return (
    <header>
      <div className="header">
        <Container fluid>
          <div className="row">
            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col logo_section">
              <div className="full">
                <div className="center-desk">
                  <div className="logo">
                    <a
                      href="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToTop();
                      }}
                      aria-label="Nachiketa Yoga - Best Yoga Classes in Bopal, Ahmedabad"
                    >
                      <img
                        src={IMAGES.logo}
                        alt="Nachiketa Yoga - Yoga Classes in Bopal, Ahmedabad"
                        width="120px"
                        height="120px"
                        style={{ objectFit: "contain" }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9">
              <Navbar
                expand="md"
                className="navigation navbar-dark custom-navbar"
                expanded={expanded}
              >
                <Navbar.Toggle
                  aria-controls="navbarsExample04"
                  onClick={toggleMenu}
                  style={{
                    position: "fixed",
                    right: "10px",
                    top: "20px",
                    zIndex: "1000",
                  }}
                />
                <Navbar.Collapse
                  id="navbarsExample04"
                  className={expanded ? "show-menu" : ""}
                >
                  <Nav className="me-auto">
                    <Nav.Link
                      href="#"
                      className={`nav-link-home ${
                        activeLink === "home" ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToTop();
                      }}
                    >
                      Home
                    </Nav.Link>
                    <Nav.Link
                      href="#classes"
                      className={`nav-link-classes ${
                        activeLink === "classes" ? "active" : ""
                      }`}
                      onClick={() => handleNavClick("classes")}
                    >
                      Classes
                    </Nav.Link>
                    <Nav.Link
                      href="#pricing"
                      className={`nav-link-pricing ${
                        activeLink === "pricing" ? "active" : ""
                      }`}
                      onClick={() => handleNavClick("pricing")}
                    >
                      Pricing
                    </Nav.Link>
                    <Nav.Link
                      href="#pictures"
                      className={`nav-link-pictures ${
                        activeLink === "pictures" ? "active" : ""
                      }`}
                      onClick={() => handleNavClick("pictures")}
                    >
                      We!
                    </Nav.Link>
                    <Nav.Link
                      href="#about"
                      className={`nav-link-about ${
                        activeLink === "about" ? "active" : ""
                      }`}
                      onClick={() => handleNavClick("about")}
                    >
                      About
                    </Nav.Link>
                    <Nav.Link
                      href="#contact"
                      className={`nav-link-contact ${
                        activeLink === "contact" ? "active" : ""
                      }`}
                      onClick={() => handleNavClick("contact")}
                    >
                      Contact
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
            </div>
          </div>
        </Container>
      </div>
      <Banner />
    </header>
  );
}

export default Header;
